import { Component, effect, ElementRef, input, output, viewChild } from '@angular/core';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import type { FeedbackType } from '../../models/detail-view-model';

@Component({
  selector: 'app-detail-feedback-modal',
  imports: [CdkDrag, CdkDragHandle],
  templateUrl: './detail-feedback-modal.component.html',
  styleUrl: './detail-feedback-modal.component.scss',
})
export class DetailFeedbackModalComponent {
  private _feedbackPanel = viewChild<ElementRef<HTMLElement>>('feedbackPanel');
  private _wasOpen = false;

  open = input<boolean>(false);
  feedbackType = input<FeedbackType>('up');
  feedbackReasons = input<string[]>([]);
  selectedReasons = input<Set<string>>(new Set());
  feedbackComment = input<string>('');
  submitting = input<boolean>(false);
  error = input<boolean>(false);

  closed = output<void>();
  reasonToggled = output<string>();
  commentChanged = output<string>();
  submitRequested = output<void>();

  constructor() {
    effect(() => {
      const isOpen = this.open();
      if (isOpen && !this._wasOpen) {
        queueMicrotask(() => this._feedbackPanel()?.nativeElement.focus());
      }
      this._wasOpen = isOpen;
    });
  }

  isFeedbackReasonSelected(reason: string): boolean {
    return this.selectedReasons().has(reason);
  }

  onCommentInput(event: Event): void {
    this.commentChanged.emit((event.target as HTMLTextAreaElement).value);
  }
}
